import {
  POPULATE_WORKSPACES,
  SET_PENDING_WORKSPACE_INVITES,
  TOGGLE_SELECT_WORKSPACE_MODAL,
  UPDATE_UNSEEN_NOTIFICATIONS,
  UPDATE_WORKSPACE_ADMINS,
  UPDATE_WORKSPACE_DETAILS,
} from '../constants/actions';

const DEFAULT_STATE = {
  workspaces: [],
  showSelectWorkspaceModal: false,
  pendingInvites: [],
  admins: [],
  isFetching: true,
};

const workspaceReducer = (state = DEFAULT_STATE, action) => {
  let newState = state;

  switch (action.type) {
    case POPULATE_WORKSPACES:
      newState = {
        ...state,
        workspaces: action.workspaces,
        isFetching: false,
      };

      break;
    case UPDATE_WORKSPACE_DETAILS:
      newState = {
        ...state,
        workspaces: state.workspaces.map(workspace => {
          if (workspace.id !== action.workspace.id) {
            return { ...workspace };
          }

          return {
            ...workspace,
            ...action.workspace,
          };
        }),
      };

      break;
    case TOGGLE_SELECT_WORKSPACE_MODAL:
      newState = {
        ...state,
        showSelectWorkspaceModal: action.showModal,
      };

      break;
    case SET_PENDING_WORKSPACE_INVITES:
      newState = {
        ...state,
        pendingInvites: [...action.pendingInvites],
      };

      break;
    case UPDATE_WORKSPACE_ADMINS:
      newState = {
        ...state,
        workspaces: state.workspaces.map(workspace => {
          if (workspace.id !== action.id) {
            return workspace;
          }

          return {
            ...workspace,
            admins: action.admins,
          };
        }),
      };
      break;
    case UPDATE_UNSEEN_NOTIFICATIONS:
      newState = {
        ...state,
        workspaces: state.workspaces.map(workspace => {
          if (workspace.id !== action.id) {
            return workspace;
          }

          return {
            ...workspace,
            counts: { ...workspace.counts, unseenNotifications: action.count },
          };
        }),
      };
      break;
    default:
      newState = state;
  }

  newState.selectedWorkspace = newState.workspaces.find(
    workspace => workspace.isSelected
  );

  return newState;
};

export default workspaceReducer;
